import React from "react";

function EditRegions(props) {
  return <div></div>;
}

export default EditRegions;
